import api from '../call'

export default {
  authenticate: async (email, password, admin) => {
    var formData = new FormData()
    formData.append('email', email)
    formData.append('password', password)
    formData.append('admin', admin)
    return await api.apiCall('POST','api/auth', 'login', formData)
  },
  logout: async () => {
    return await api.apiCall('POST','api/auth', 'logout')
  },
  refresh_user: async () => {
    return await api.apiCall('GET', 'api/auth', 'refresh')
  },
  changePassword: async (data) => {
    return await api.apiCall('PUT', 'api/auth', 'change-password', {'old': data['old'], 'new': data['new'], 'newConfirm': data['newConfirm']})
  },
  validate_invite_token: async (data) => {
    if(Object.keys(data).includes('password')){
      return api.apiCall('POST', 'api/auth', `validate-token/${data.token}`, {'password': data.password})
    }else{
      return api.apiCall('POST', 'api/auth', `validate-token/${data.token}`)
    }
  },
  accept_invite_token: async (token) => {
    return api.apiCall('POST', 'api/auth', `accept-invite/${token}`)
  }

}
